import { AddRemittanceContext } from '../../../../../components/Purchasing/Remittance/AddRemittance/AddRemittanceCont'
import moment from 'moment'
import React from 'react'
import { Col, Divider, Form, InputNumber, Row } from 'antd'
import { get } from 'lodash'

import { defaultFormItemLayout } from '../../../../../modules/FormItems'
import _ from 'lodash'

export const ReadField = props => (
  <div
    style={{
      width: `50%`,
      margin: '0 0 25px 0',
      display: 'inline-block',
      verticalAlign: 'top',
    }}>
    <div style={{ fontSize: '18px', marginBottom: '10px', fontWeight: 'bold' }}>{props.label}</div>
    <div style={{ fontSize: '16px', marginRight: '10px' }}>{props.value}</div>
  </div>
)

function RemittanceLinesForm(props) {
  const { line } = React.useContext(AddRemittanceContext)

  const { voucher } = line
  const { getFieldDecorator } = props.form
  return (
    <Form>
      <Row>
        <Col offset={4} span={20}>
          <Row>
            <ReadField label={'Code'} value={_.get(voucher, 'code')} />
            <ReadField label={'Claim Type'} value={_.get(voucher, 'type')} />
          </Row>
          <Row>
            <ReadField label={'Date'} value={moment(_.get(voucher, 'date')).format('DD-MM-YYYY')} />
            <ReadField label={'Remarks'} value={_.get(voucher, 'remarks')} />
          </Row>
          <Row>
            <ReadField label={'Main Rep'} value={_.get(voucher, 'notify.main.fn')} />
            <ReadField label={'Currency'} value={_.get(voucher, 'currency')} />
          </Row>
          <Row>
            <ReadField label={'Amount'} value={_.get(voucher, 'amount')} />
            <ReadField label={'Company'} value={_.get(voucher, 'company.fn')} />
          </Row>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Allocation">
            {getFieldDecorator('allocation', {
              initialValue: get(line, 'allocation'),
            })(<InputNumber style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

RemittanceLinesForm.propTypes = {}
RemittanceLinesForm.defaultProps = {}

export default Form.create()((RemittanceLinesForm))
